import React, { createContext, useContext } from 'react'

interface LocationContextType {
    locationFromGps: Coordinates | null
    locationFromUser: Coordinates | null
    locationAsString: string
    locationError: string | null
    setLocationFromGps: React.Dispatch<React.SetStateAction<Coordinates | null>>
    setLocationFromUser: React.Dispatch<React.SetStateAction<Coordinates | null>>
    setLocationAsString: React.Dispatch<React.SetStateAction<string>>
    setLocationError: React.Dispatch<React.SetStateAction<string | null>>
}

const LocationContext = createContext<LocationContextType | null>(null)

export const useLocation = () => {
    const context = useContext(LocationContext)
    if (context === null) throw new Error("useLocation must be used within a LocationProvider")
    return context
}

export default LocationContext
